import React from 'react';
import { useTranslation } from 'react-i18next';

import { Model } from '../../../../../../viewer/elements/model';
import { publish, SubscriptionTopic } from '../../../../../../viewer/messaging/pubsub';
import { useNonce } from '../../../../../hooks/use-nonce';
import { useSharedView } from '../../../../../hooks/use-shared-view';
import { LabelledContainer } from '../../../../labelled-container/labelled-container';
import { Switch } from '../../../../switch/switch';
import { useAsset } from '../../../hooks/use-asset';
import { TimelineSection } from '../../components/timeline-section';

type Props = {
  asset: Model;
};

const ModelBody = (props: Props) => {
  const { t } = useTranslation();
  const [_, refresh] = useNonce();
  const [locked, setLocked] = React.useState(props.asset.locked);
  const { isSharedView } = useSharedView();

  useAsset(props.asset, {
    onAssetChanged: refresh,
  });

  const toggleLock = React.useCallback(async () => {
    try {
      props.asset.locked = !props.asset.locked;
      props.asset.loadingStatus = 'loading';
      refresh();
      await props.asset.save();
      setLocked(props.asset.locked);
    } catch (err) {
      props.asset.locked = !props.asset.locked;
      publish(SubscriptionTopic.ToastrMessage, {
        type: 'error',
        message: props.asset.locked
          ? t('model.unlockFailedMessage', { ns: 'skyviewAssetMenu' })
          : t('model.lockFailedMessage', { ns: 'skyviewAssetMenu' }),
      });
    } finally {
      props.asset.loadingStatus = 'loaded';
      refresh();
    }
  }, [props.asset, refresh, t]);

  return (
    <>
      <TimelineSection asset={props.asset} />

      {!isSharedView && (
        <LabelledContainer text={t('model.section.locked', { ns: 'skyviewAssetMenu' })}>
          {(formElementId) => (
            <Switch
              checked={locked}
              disabled={props.asset.loadingStatus !== 'loaded'}
              id={formElementId()}
              onChange={toggleLock}
            />
          )}
        </LabelledContainer>
      )}
    </>
  );
};

export { ModelBody, Props as ModelBodyProps };
